import { action, makeObservable, observable } from "mobx";
import { parseJwt } from "../utils";

class AuthStore {

  accessToken: string | null = null;
  refreshToken: string | null = null;
  userId: string | null = null;
  currency: string | null = null;

  constructor() {
    makeObservable(this, {
      accessToken: observable,
      refreshToken: observable,
      setAccessToken: action.bound,
      setRefreshToken: action.bound,
    })
  }

  setAccessToken = (token: string | null) => {
    this.accessToken = token;
    if (token) {
      const payload = parseJwt(token);
      this.userId = payload.sub;
      this.currency = payload.currency;
    }
  }

  setRefreshToken = (token: string | null) => {
    this.refreshToken = token;
  }

}

export const authStore = new AuthStore();
